import React, { useState, useEffect } from "react";

const FormattedDate = ({ date }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); 

    return () => clearInterval(intervalId); 
  }, []);

  const formattedDay = date.toLocaleDateString(undefined, { weekday: "long" });
  const formattedDate = date.toLocaleDateString(undefined, {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  const formattedTime = currentTime.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  return (
    <div>
       Local Time: {formattedTime} <br/>
      {formattedDay}, {formattedDate}. 
    </div>
  );
};

export default FormattedDate;